/**
 Tokens:
  '#': {pattern: /\d/},
  'X': {pattern: /[0-9a-zA-Z]/},
  'S': {pattern: /[a-zA-Z]/},
  'A': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase()},
  'a': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase()},
*/

export const maskTypes = Object.freeze({
  birthDate: '##/##/####',
  cardNumber: ['#### #### #### ####', '#### ###### ######'],
  cellphone: '(##) #####-####',
  cep: '#####-###',
  cpf: '###.###.###-##',
  expirationDate: '##/##',
  phone: '(##) ####-####',
  securityCode: '####'
});
